import React, { useState } from 'react';
import img1_1 from '../media/img1-1.png';
import img1_2 from '../media/img1-2.png';
import img2_1 from '../media/harcorp-begin.png';
import img2_2 from '../media/harcorp-end.png';


const technologies = ['React.js', 'Python', 'FastAPI', 'OpenAI API', 'Vector databases', 'Docker', 'Cloud infrastructure'];
const features = ['Document upload & processing', 'Natural language querying', 'Context-aware responses', 'Interactive chat interface', 'Secure data handling', 'Performance monitoring'];
const screenshots = [
  { src: img1_2, alt: 'Application interface' },
  { src: img1_1, alt: 'Query results' },
];
const harcorp_screenshots = [
  { src: img2_1, alt: 'Application interface' },
  { src: img2_2, alt: 'Query results' },
];


const Project1Page = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);
  const [imageAlt, setImageAlt] = useState('');

  const openModal = (imageSrc, alt) => {
    setCurrentImage(imageSrc);
    setImageAlt(alt);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setCurrentImage(null);
    setImageAlt('');
  };

  return (
    <div className="page-shell">
      <div className="page-shell__content section-stack">
        <section className="section-card center-text">
          <div className="eyebrow">Featured project</div>
          <h1 className="page-title">Insurance Projects</h1>
          <p className="page-copy" style={{ marginLeft: 'auto', marginRight: 'auto' }}>
            AI solutions for processing and understanding documentation and insurance terminology.
          </p>
        </section>

        <section className="section-card">
          <h2 className="section-title">Penn Insurance</h2>
          <h3 style={{ fontSize: '1.2rem', marginBottom: '0.75rem', color: 'var(--text)' }}>Overview</h3>
          <p className="page-copy">
            This site is a demo sent to Penn National Insurance after some of their staff noted that reading through their documentation was consuming more time than they could spare. I made this to show how I could help their company as a contract software engineer. Negotiation is currently under way.
          </p>
          <p className="page-copy" style={{ marginBottom: 0 }}>
            Check it out:{' '}
            <a className="subtle-link" href="http://penn-demo.team-stingray.com" target="_blank" rel="noopener noreferrer">
              penn-demo.team-stingray.com
            </a>
          </p>
        </section>

        <div className="two-column-grid">
          <section className="section-card">
            <h2 className="section-title">Technology used</h2>
            <ul className="bullet-list">
              {technologies.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </section>

          <section className="section-card">
            <h2 className="section-title">Features</h2>
            <ul className="bullet-list">
              {features.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </section>
        </div>

        <section className="section-card">
          <h2 className="section-title">Penn Insurance Screenshots</h2>
          <div className="image-grid">
            {screenshots.map((shot) => (
              <div key={shot.alt} className="image-card">
                <img
                  src={shot.src}
                  alt={shot.alt}
                  className="image-thumb"
                  onClick={() => openModal(shot.src, shot.alt)}
                />
                <p className="caption">{shot.alt}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="section-card">
          <h2 className="section-title">Harcorp Life</h2>
          <h3 style={{ fontSize: '1.2rem', marginBottom: '0.75rem', color: 'var(--text)' }}>Overview & Purpose</h3>
          <p className="page-copy">
            Made for Harcorp Life to help with their mission to educate users on life insurance by providing a way to look up insurance terms and get definitions.
          </p>
          <p className="page-copy" style={{ marginBottom: '1.5rem' }}>
            Check it out:{' '}
            <a className="subtle-link" href="https://maxs-harcorp-demo.team-stingray.com/" target="_blank" rel="noopener noreferrer">
              maxs-harcorp-demo.team-stingray.com
            </a>
          </p>

          <h3 style={{ fontSize: '1.2rem', marginBottom: '0.75rem', color: 'var(--text)' }}>Architecture & Technical Explanation</h3>
          <p className="page-copy" style={{ marginBottom: '1.5rem' }}>
            Used Postgres with the ParadeDB extension to run similarity search within Postgres to find terms similar to what the user typed and sort by similarity.
          </p>

          <h3 style={{ fontSize: '1.2rem', marginBottom: '0.75rem', color: 'var(--text)' }}>Harcorp Life Screenshots</h3>
          <div className="image-grid">
            {harcorp_screenshots.map((shot) => (
              <div key={'harcorp-' + shot.alt} className="image-card">
                <img
                  src={shot.src}
                  alt={'Harcorp ' + shot.alt}
                  className="image-thumb"
                  onClick={() => openModal(shot.src, 'Harcorp ' + shot.alt)}
                />
                <p className="caption">Harcorp Life - {shot.alt}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="section-card">
          <h2 className="section-title">Outcome</h2>
          <p className="page-copy" style={{ marginBottom: 0 }}>
            These applications served as successful demos to show how I could help companies solve real problems with AI and search technologies.
          </p>
        </section>

      </div>

      {modalOpen && (
        <div className="modal-backdrop" onClick={closeModal}>
          <div className="modal-card" onClick={(event) => event.stopPropagation()}>
            <button type="button" className="modal-close" onClick={closeModal} aria-label="Close image preview">
              &times;
            </button>
            <img src={currentImage} alt={imageAlt} className="modal-image" />
            <p className="caption">{imageAlt}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Project1Page;
